module.exports = __webpack_public_path__ + "img/pp-yellow.bb3ed0e0.png";